import type { Components } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';

import type { Theme } from '../types';

export const MuiTableHead = {
  styleOverrides: {
    root: ({ theme }) => {
      const isDark = theme.palette.mode === 'dark';
      return {
        [`& .${tableCellClasses.root}`]: {
          backgroundColor: isDark
            ? 'var(--mui-palette-neutral-900)'
            : 'var(--mui-palette-background-level1)',
          color: 'var(--mui-palette-text-secondary)',
          fontSize: '0.75rem',
          fontWeight: 600,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          lineHeight: 1.4,
          borderBottom: `1px solid ${
            isDark ? 'rgba(255, 255, 255, 0.06)' : 'var(--mui-palette-divider)'
          }`,
        },
      };
    },
  },
} satisfies Components<Theme>['MuiTableHead'];
